import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { AssetCreateWizard } from '../../components/AssetCreateWizard'
import { useBreadcrumbs } from '../../hooks/useBreadcrumbs'

type BuildingGroupSearch = {
  asset_uid?: string
  step?: number
}

export const Route = createFileRoute('/$org/createBuildingGroup')({
  component: RouteComponent,
  validateSearch: (search: any): BuildingGroupSearch => {
    const stepValue = search.step
    const asset_uid = search.asset_uid as string | undefined
    let step: number | undefined = undefined

    // This wizard owns steps 1-2 (address+type, create buildings).
    if (typeof stepValue === 'number') {
      step = stepValue >= 1 && stepValue <= 2 ? stepValue : undefined
    } else if (typeof stepValue === 'string') {
      const parsed = parseInt(stepValue, 10)
      if (!isNaN(parsed) && parsed >= 1 && parsed <= 2) {
        step = parsed
      }
    }

    // If no (valid) step is specified but asset_uid is present, default to the
    // last step of this wizard (create buildings) — the group already exists.
    if (step === undefined && asset_uid) {
      step = 2
    }
    
    return {
      asset_uid,
      step,
    }
  },
})

function RouteComponent() {
  const { org } = Route.useParams()
  const { asset_uid, step } = Route.useSearch()
  const { t } = useTranslation('assets')
  const { t: tCommon } = useTranslation('common')

  // Set up breadcrumbs
  useBreadcrumbs([
    { title: tCommon('nav.home'), path: `/${org}` },
    { title: t('list.title_all'), path: `/${org}/assets` },
    { title: t('create_building.breadcrumb_group') }
  ])

  return <AssetCreateWizard resumeAssetUid={asset_uid} resumeStep={step} />
}